import { render, staticRenderFns } from "./electronicFence.vue?vue&type=template&id=3796bcc5&scoped=true&"
import script from "./electronicFence.vue?vue&type=script&lang=js&"
export * from "./electronicFence.vue?vue&type=script&lang=js&"
import style0 from "./electronicFence.vue?vue&type=style&index=0&id=3796bcc5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796bcc5",
  null
  
)

export default component.exports